import {combineReducers} from "@reduxjs/toolkit";
import profile from "store/reducer/user/profile/reducer";
import settings from "./settings/reducer";
import subscription from "./subscription/reducer";

export default combineReducers({
    profile,
    settings,
    subscription
});

